// @ts-check
import * as R from "ramda";

export { default as useTOSStatus } from "./useTOSStatus";
export { default as useSignTOS } from "./useSignTOS";

/**
 * The two Tilia ToS endpoints (`getTOSStatus`, `signTiliaTOS`) live in the `api/accounts.js`
 * *file*, while `api/accounts/` is a separate directory with its own `index.js`. Since
 * `import ... from "api/accounts"` resolves to the file, a hook placed in `api/accounts/` would
 * have to import from `"api/accounts"` — reading as a self-import — so these hooks live here
 * instead. They follow the shape of `api/accounts/useGetPrimaryEmail.js`, just not its location.
 */

/**
 * isSignedTOS
 * @param {object} [data] - a `getTOSStatus` response
 * @returns {boolean}
 * @description The single reader of `payload.signed_tos`. Anything that needs to know whether the
 * user has accepted the ToS goes through here so the standalone page and inline consent cannot
 * drift apart.
 */
export const isSignedTOS = R.pathEq(["payload", "signed_tos"], true);

/**
 * tosQueryKey
 * @param {string} [accountId] - `account_id` claim from the session JWT
 * @returns {Array<string|undefined>}
 * @description Account-scoped on purpose: `api/queryClient.js` is a module singleton that lives as
 * long as the document and `staleTime: Infinity` means entries never expire, so an unscoped key
 * would serve one account's `signed_tos: true` to another after a session change via
 * `/appauth/:token` (a client-side route).
 */
export const tosQueryKey = (accountId) => ["tos", "tilia", accountId];
